import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const HalfDayWorkshopPage = lazy(() => import('../pages/workshops/half-day/page'));
const FullDayWorkshopPage = lazy(() => import('../pages/workshops/full-day/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServiceAreasPage = lazy(() => import('../pages/service-areas/page'));
const FAQsPage = lazy(() => import('../pages/faqs/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const FileManager = lazy(() => import('../pages/admin/files/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/workshops/half-day',
    element: <HalfDayWorkshopPage />,
  },
  {
    path: '/workshops/full-day',
    element: <FullDayWorkshopPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/service-areas',
    element: <ServiceAreasPage />,
  },
  {
    path: '/faqs',
    element: <FAQsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/files',
    element: <FileManager />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
